import {createAction} from 'web-app/util/redux/famly-app-helpers';

import {type ReplyStatus} from './constants';

const domain = 'VACATION_PLANNING';

export const {
    action: fetch,
    success: fetchSuccess,
    failed: fetchFailed,
} = createAction(
    `${domain}/FETCH`,
    (institutionId: string) => ({institutionId}),
    (response: any) => ({response}),
);

export const {
    action: fetchSingle,
    success: fetchSingleSuccess,
    failed: fetchSingleFailed,
} = createAction(
    `${domain}/FETCH_SINGLE`,
    (vacationId: string) => ({vacationId}),
    (response: any) => ({response}),
);

export const {
    action: deleteVacationPlan,
    success: deleteVacationPlanSuccess,
    failed: deleteVacationPlanFailed,
    aborted: deleteVacationPlanAborted,
} = createAction(
    `${domain}/DELETE_VACATION_PLAN`,
    (vacationId: string) => ({vacationId}),
    (response: any) => ({response}),
);

export const {action: selectStatusOption} = createAction(`${domain}/SELECT_STATUS_OPTION`, (status: ReplyStatus) => ({
    status,
}));
